module.exports = __webpack_public_path__ + "img/d1.21084823.jpg";